const url = '/manager';
// 담당자 리스트
export const getManagerDataList = async (conn, callback, reject, pager, setLoading) => {
  const { take, skip, userTerm, rgnCode, dongCode } = pager;
  const config = {
    params: {
      page: (take + skip) / take,
      size: take,
      userTerm: userTerm,
      rgnCode: rgnCode,
      dongCode: dongCode,
    },
  };
  await conn
    .get(url + '/page', config)
    .then(response => {
      callback(response);
      setLoading(false);
    })
    .catch(error => {
      reject(error);
    });
};

export const setUpdateManager = async (conn, data) => {
  const response = await conn.post(url, data);

  return response;
};

export const setDeleteManager = async (conn, data) => {
  const config = {
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify(new Array(data)),
  };
  const response = await conn.delete(url, config);

  return response;
};

export const getAllManagerList = async conn => {
  const response = await conn.get(url + '/all/list');
  response.forEach(element => {
    element.userTerm = element.userTerm + ' (' + element.dongTermSimple + ')';
  });
  return response;
};

export const checkDuplicatedId = async (conn, userId) => {
  const config = {
    params: {
      userId: userId,
    },
  };
  const response = await conn.get('/user/duplicateId', config);

  return response;
};

export const checkDuplicatedCid = async (conn, cid) => {
  const config = {
    params: {
      cid: cid,
    },
  };
  const response = await conn.get('/user/duplicateCid', config);

  return response;
};

export const setManagerInsert = async (conn, data) => {
  const { userId, userTerm, userPassword, rgnCode, dongCode, userPhone, protectorPhone } = data;
 
  const params = {
    userId: userId, 
    userTerm: userTerm,
    userTypeCode: 2002,
    userPassword: userPassword,
    rgnCode: rgnCode,
    dongCode: dongCode,
    userPhone: userPhone,
    protectorPhone: protectorPhone,
  };

  const response = await conn.post(url + "/insert", params);

  return response;
};


export const setManagerUpdate = async (conn, data) => {
  const { userId, userTerm, userPassword, rgnCode, dongCode, userPhone, protectorPhone } = data;
 
  const params = {
    userId: userId, 
    userTerm: userTerm,
    userTypeCode: 2002,
    userPassword: userPassword,
    rgnCode: rgnCode,
    dongCode: dongCode,
    userPhone: userPhone,
    protectorPhone: protectorPhone,
  };

  const response = await conn.post(url + "/update", params);

  return response;
};